import React, { useContext, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';

import ProductSearch from '../../../../components/product-search';
import { ViewportContext } from '../../../../components/viewport';

import { toggleSearchInput as toggleSearchInputAction } from '../../actions';

import { RelatedProduct } from '../../../../types';
import { OnSelect } from '../../../../components/product-search/types';

import * as S from './styles';

type OwnProps = {
  focusOnMount: boolean;
  onSelect: OnSelect;
  relatedProducts: RelatedProduct[];
  showNewComparePageLayout: boolean;
  showSearchInHeader: boolean;
  showCloseButton?: boolean;
};

type DispatchProps = {
  toggleSearchInput: () => void;
};

type Props = OwnProps & DispatchProps;

const ProductFinder = ({
  onSelect,
  focusOnMount,
  relatedProducts,
  showNewComparePageLayout,
  showSearchInHeader,
  toggleSearchInput,
  showCloseButton = false,
}: Props) => {
  const { isDesktop } = useContext(ViewportContext);

  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        toggleSearchInput();
      }
    },
    [toggleSearchInput]
  );

  useEffect(() => {
    if (showSearchInHeader) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <S.ProductFinderWrapper showSearchInHeader={showSearchInHeader}>
      <S.ProductFinder showSearchInHeader={showSearchInHeader}>
        <ProductSearch
          onSelect={onSelect}
          focusOnMount={focusOnMount}
          showFloatingResult
          relatedProducts={relatedProducts}
          showNewComparePageLayout={showNewComparePageLayout}
          relatedProductsAsOverlay={showSearchInHeader}
        />

        {showCloseButton && !isDesktop && (
          <S.CloseSearchButton onClick={toggleSearchInput} onlyIcon>
            <span style={{ display: 'flex' }}>
              <S.CloseIcon size={28} />
            </span>
          </S.CloseSearchButton>
        )}
      </S.ProductFinder>
    </S.ProductFinderWrapper>
  );
};

const dispatchActions = {
  toggleSearchInput: toggleSearchInputAction,
};

export default connect(undefined, dispatchActions)(ProductFinder);
